import { IonCard, IonCardContent } from "@ionic/react";
import WithNavigation from "../../hoc/with-navigation";
import { useContext, useEffect } from "react";
import { useFaq } from "../../store/faq";
import HintsModal from "../../components/modals/hints";
import { LocalizationContext } from "../../App";
import { translate, translateHtml } from "../../utils/helpers";

import "./styles.css";

const Faq = () => {
	const faqStore = useFaq();

	const locales = useContext(LocalizationContext);

	useEffect(() => {
		faqStore.loadFaqList();
	}, []);

	return (
		<>
			<WithNavigation preventGoBack={false} text="FAQ">
				<div className="form">
					<IonCard>
						<IonCardContent>
							<>
								{faqStore.faqList &&
									faqStore.faqList.map((f, i) => (
										<p
											className="faq-title"
											key={i}
											onClick={() => faqStore.setModalContent(f)}
										>
											{translate(f.title, locales)}
										</p>
									))}
							</>
						</IonCardContent>
					</IonCard>
					{faqStore.modalContent && (
						<HintsModal
							visible={!!faqStore.modalContent}
							title={translate(faqStore.modalContent.title, locales)}
							hintsContent={translateHtml(
								faqStore.modalContent.htmlDef,
								locales
							)}
							onClose={() => faqStore.setModalContent(null)}
						/>
					)}
				</div>
			</WithNavigation>
		</>
	);
};

export default Faq;
